import Joi from 'joi';
import { joiResolver } from '@hookform/resolvers/joi';
import { FieldsName } from './consts';

/**
 * The release date is kept as a plain `YYYY-MM-DD` string, not a `Date`: the
 * date input hands back a string and the server reads one. `isoDate` would
 * rewrite it into a full timestamp, which would move the day for anyone east
 * of UTC, so the shape is checked with a pattern instead.
 */
const schema = Joi.object({
  [FieldsName.title]: Joi.string().trim().required(),
  [FieldsName.artistName]: Joi.string().trim().required(),
  [FieldsName.releaseDate]: Joi.string()
    .pattern(/^\d{4}-\d{2}-\d{2}$/)
    .required(),
});

export const resolver = joiResolver(schema);
